import React from 'react';
import './Spinner.css';

const Spinner = () => (
  <div className="spinner">
    <div className="dot1" />
    <div className="dot2" />
  </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/common/Spinner.js